var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { useCombobox, useMultipleSelection } from 'downshift';
import { FloatingContextProvider } from '../utils/floating/index.js';
import { MultiselectButton, MultiselectSelectedItem, } from './MultiselectButton.js';
import { MultiselectContext } from './MultiselectContext.js';
import { MultiselectItem, MultiselectItems, MultiselectItemsEmpty, } from './MultiselectItems.js';
export const Multiselect = (props) => {
    const { children, value, options, onChange, className, disabled = false, searchable = false, onInputChange, invalid = false } = props, rest = __rest(props, ["children", "value", "options", "onChange", "className", "disabled", "searchable", "onInputChange", "invalid"]);
    const dsMultiple = useMultipleSelection({
        initialSelectedItems: value,
        onSelectedItemsChange: changes => {
            var _a;
            const newItemsLength = (_a = changes.selectedItems) === null || _a === void 0 ? void 0 : _a.length;
            if (typeof onChange === 'function' &&
                newItemsLength !== (value === null || value === void 0 ? void 0 : value.length)) {
                onChange(changes.selectedItems);
            }
        },
    });
    const dsCombobox = useCombobox({
        items: options,
        selectedItem: null,
        onSelectedItemChange: changes => {
            if (!changes.selectedItem ||
                changes.type === useCombobox.stateChangeTypes.InputBlur) {
                return;
            }
            const index = dsMultiple.selectedItems.indexOf(changes.selectedItem);
            if (index > 0) {
                dsMultiple.setSelectedItems([
                    ...dsMultiple.selectedItems.slice(0, index),
                    ...dsMultiple.selectedItems.slice(index + 1),
                ]);
            }
            else if (index === 0) {
                dsMultiple.setSelectedItems([...dsMultiple.selectedItems.slice(1)]);
            }
            else {
                dsMultiple.setSelectedItems([
                    ...dsMultiple.selectedItems,
                    changes.selectedItem,
                ]);
            }
        },
        stateReducer: (state, actionAndChanges) => {
            const { changes, type } = actionAndChanges;
            switch (type) {
                case useCombobox.stateChangeTypes.InputKeyDownEnter:
                case useCombobox.stateChangeTypes.ItemClick:
                    return Object.assign(Object.assign({}, changes), { isOpen: true, highlightedIndex: state.highlightedIndex, inputValue: state.inputValue });
                case useCombobox.stateChangeTypes.InputBlur:
                    return Object.assign(Object.assign({}, changes), { inputValue: '', isOpen: false });
                case useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem:
                    return Object.assign(Object.assign({}, changes), { inputValue: state.inputValue });
                case useCombobox.stateChangeTypes.FunctionOpenMenu:
                case useCombobox.stateChangeTypes.ToggleButtonClick:
                    return changes;
                default:
                    return Object.assign(Object.assign({}, changes), { isOpen: state.isOpen });
            }
        },
        onInputValueChange: changes => {
            if (searchable) {
                onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(changes.inputValue);
            }
        },
    });
    return (React.createElement("div", Object.assign({ className: clsx('relative isolate', className) }, rest),
        React.createElement(FloatingContextProvider, { placement: "bottom-start" },
            React.createElement(MultiselectContext.Provider, { value: Object.assign(Object.assign(Object.assign({}, dsMultiple), dsCombobox), { searchable,
                    disabled, creating: false, invalid }) }, children))));
};
Multiselect.Button = MultiselectButton;
Multiselect.SelectedItem = MultiselectSelectedItem;
Multiselect.Items = MultiselectItems;
Multiselect.ItemsEmpty = MultiselectItemsEmpty;
Multiselect.Item = MultiselectItem;
//# sourceMappingURL=Multiselect.js.map